import { trpc } from "@/lib/trpc";
import { toast } from "sonner";
import { fromError } from "zod-validation-error";

export const useCreateAgentMutation = (setLoading?: (loading: boolean) => void, setError?: (error: string) => void) => {
    const utils = trpc.useUtils();
    return trpc.agents.create.useMutation({
        onMutate: async () => {
            setLoading?.(true);
            setError?.("");
        },
        onSuccess: async () => {
            utils.agents.findMany.invalidate();
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
            setError?.(errorMessage);
        },
        onSettled: async () => {
            setLoading?.(false);
        },
    });
};

export const useUpdateAgentMutation = (setLoading?: (loading: boolean) => void, setError?: (error: string) => void) => {
    const utils = trpc.useUtils();
    return trpc.agents.update.useMutation({
        onMutate: async () => {
            setLoading?.(true);
            setError?.("");
        },
        onSuccess: async (data) => {
            utils.agents.findMany.invalidate();
            utils.agents.findOne.invalidate(data[0].id);
            toast.success("Agent updated successfully");
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
            setError?.(errorMessage);
        },
        onSettled: async () => {
            setLoading?.(false);
        },
    });
};

export const useDeleteAgentMutation = () => {
    const utils = trpc.useUtils();
    return trpc.agents.remove.useMutation({
        onSuccess: async () => {
            utils.agents.findMany.invalidate();
            toast.success("Agent deleted successfully");
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
        },
    });
};

export const useUpdateChatProviderForAgentsMutation = () => {
    const utils = trpc.useUtils();
    return trpc.agents.updateChatProviderForAgents.useMutation({
        onSuccess: async () => {
            utils.agents.findMany.invalidate();
            toast.success("Agents updated with new chat provider");
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
        },
    });
};
